import { Component, OnInit, ViewChild } from "@angular/core";
import { NavController, NavParams, LoadingController, ModalController, IonicModule, IonModal } from "@ionic/angular";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { GrupoAddReuniaoPage } from "../grupo-add-reuniao/grupo-add-reuniao.page";
import { GrupoGerenciarPage } from "../grupo-gerenciar/grupo-gerenciar.page";
import { GrupoProvider } from "src/app/services/grupo/grupo";
import { UserProvider } from "src/app/services/user/user";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { DateFormatPipe } from "src/app/pipes/date-format/date-format";
import { SafeHtmlPipe } from "src/app/pipes/safe-html/safe-html";
import { SemRegistroComponent } from "src/app/components/sem-registro/sem-registro";
import { ProverDatepickerComponent } from "src/app/components/prover-datepicker/prover-datepicker";
import { addDays, format, isBefore, isEqual, subDays } from "date-fns";
import { ToastController } from "@ionic/angular/standalone";

@Component({
  selector: "app-grupo-gerenciar-reunioes",
  templateUrl: "./grupo-gerenciar-reunioes.page.html",
  styleUrls: ["./grupo-gerenciar-reunioes.page.scss"],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    DateFormatPipe,
    TranslateModule,
    SafeHtmlPipe,
    SemRegistroComponent,
    DateFormatPipe,
    ProverDatepickerComponent,
  ],
})
export class GrupoGerenciarReunioesPage implements OnInit {
  @ViewChild("filtroModal", { static: true }) filtroModal!: IonModal;
  idGrupo: string;
  tipo: "grupo" | "ebd" | "ministerio";
  reunioes: any = [];
  reunioesFinalizadas: any;
  permissaoEditar = false;
  ordemAscendente = true;
  isHistorico = false;
  reuniaoTab = "andamento";
  dataInicio = format(subDays(new Date(), 10), "yyyy-MM-dd");
  dataFim = format(addDays(new Date(), 10), "yyyy-MM-dd");
  pagination: any = { currentPage: 0, pageCount: 0 };
  filtroAtual: any = {};

  andamento: any;
  finalizado: any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public grupoProvider: GrupoProvider,
    public loadingController: LoadingController,
    public modalCtrl: ModalController,
    public userProvider: UserProvider,
    private translate: TranslateService,
    public toastCtrl: ToastController
  ) {
    this.idGrupo = this.navParams.get("idGrupo");
    this.tipo = this.navParams.get("tipo");
  }

  public closeModal() {
    this.modalCtrl.dismiss(true);
  }

  ngOnInit() {
    this.carregarReunioes(null, false);
    this.carregarReunioes(null, true);
  }

  carregarReunioes(
    infiniteScroll: { target: { complete: () => void } } | null,
    isHistorico: boolean
  ) {
    if (!infiniteScroll) {
      this.pagination = { currentPage: 0, pageCount: 10 };

      if (isHistorico) {
        this.reunioesFinalizadas = [];
      } else {
        this.reunioes = [];
      }
    }

    const filtroAtual = {
      dataInicio: this.dataInicio,
      dataFim: this.dataFim,
      ordem: this.ordemAscendente,
      idParticipante: null,
      isHistorico
    };

    this.grupoProvider
      .postReunioes(this.idGrupo, filtroAtual, this.pagination)
      .subscribe((res) => {

        if (isHistorico) {
          this.reunioesFinalizadas = [
            ...this.reunioesFinalizadas,
            ...res.dados
          ];
        } else {
          this.reunioes = [
            ...this.reunioes,
            ...res.dados
          ];
        }

        this.pagination = res.pagination;
        this.permissaoEditar = res.permissaoEditar;
        this.alterarVariavel();

        if (infiniteScroll) {
          infiniteScroll.target.complete();
        }
      });
  }

  async filtrar() {
    const result =
      isBefore(new Date(this.dataInicio), new Date(this.dataFim)) ||
      isEqual(new Date(this.dataInicio), new Date(this.dataFim));

    if (!result) {
      const toast = await this.toastCtrl.create({
        message: this.translate.instant("Informe uma data válida"),
        duration: 3000,
      });
      toast.present();
    } else {
      this.ngOnInit();
      this.filtroModal.dismiss();
    }
  }

  orderDescAsc() {
    this.ordemAscendente = !this.ordemAscendente;
    this.carregarReunioes(null, this.isHistorico);
  }

  async addReuniao() {
    var data = { idGrupo: this.idGrupo };
    const modalPage = await this.modalCtrl.create({
      component: GrupoAddReuniaoPage,
      componentProps: data,
    });
    modalPage.present();

    const modalResult = await modalPage.onDidDismiss();
    if (modalResult.data) {
      this.carregarReunioes(null, false);
    }
  }

  validaQtdHorasDisponivelEdicao(reuniao: any) {
    const qtdHorasStr = reuniao["qtdHorasDisponivelEdicao" + this.tipo.charAt(0).toUpperCase() + this.tipo.slice(1)];

    if (qtdHorasStr === null) {
      return true;
    }

    const [qtdHoras, qtdMinutos] = qtdHorasStr.split(":").map(Number);

    const dataFim = new Date(reuniao.dataFim);
    const agora = new Date();

    const diferencaEmMilissegundos = agora.getTime() - dataFim.getTime();
    const diferencaEmMinutos = diferencaEmMilissegundos / (1000 * 60);

    const diferencaHoras = Math.floor(diferencaEmMinutos / 60);
    const diferencaMinutos = diferencaEmMinutos % 60;

    return diferencaHoras < qtdHoras || (diferencaHoras === qtdHoras && diferencaMinutos <= qtdMinutos);
  }

  async selecionarReuniao(reuniao: any) {
    let readOnly =
      this.userProvider.hasConfig(12) && reuniao.status === 1 && !this.validaQtdHorasDisponivelEdicao(reuniao);
    const data = {
      idGrupo: this.idGrupo,
      reuniao: reuniao,
      readOnly: readOnly,
      tipo: this.tipo,
    };

    const modalPage = await this.modalCtrl.create({
      component: GrupoGerenciarPage,
      componentProps: data,
    });
    modalPage.present();
    const modalResult = await modalPage.onDidDismiss();
    if (modalResult) {
      this.ngOnInit()
    }
  }

  alterarVariavel() {
    this.andamento = this.reunioes.filter((x: { status: any }) => x.status == 0);
    this.finalizado = this.reunioes.filter((x: { status: any }) => x.status == 1);
  }

  onSegmentChange(event: any) {
    this.isHistorico = event.detail.value === 'finalizado';
  }

}
